import { useQuery } from "@tanstack/react-query";
import get from "lodash/get";
import DocumentDraftService from "../../services/DocumentDraftService";

const useDraft = (draftId, options) => {
  return useQuery({
    queryKey: ["draft", draftId],
    queryFn: async () => {
      if (!draftId) return null;
      const data = await DocumentDraftService.getById(draftId);
      return get(data, "data", null);
    },
    ...options,
  });
};

export default useDraft;
